import { getClient } from '@lib/sanity'
import { loadTranslation } from '@lib/i18n'
import { groq } from 'next-sanity'
import SubjectsIndex from 'components/SubjectsIndex'

const regionsQuery = groq`*[_type == "subject"] | order(lower(name) asc)`

export const getStaticProps = async ({ locale, params, preview = false }) => {
  const translation = await loadTranslation(
    locale,
    process.env.NODE_ENV === 'production'
  )
  const items = await getClient(preview).fetch(regionsQuery, {
    locale,
  })

  return {
    props: {
      translation,
      items,
      preview,
    },
    revalidate: 60 * 5, // Every five mins
  }
}

export default SubjectsIndex
